import { USER_ROLE } from 'utils/enums/user-role.enum';
import Cookies from 'js-cookie';
import type { RoleTypeResponse } from 'utils/types/user';

export function handleRole(): RoleTypeResponse {
	const role = Cookies.get('role');

	return {
		admin: role === USER_ROLE.ADMIN,
		writer: role === USER_ROLE.WRITER || role === USER_ROLE.SOURCER,
		moderator: role === USER_ROLE.MODERATOR,
	};
}
